import { useState, useEffect } from "react";
import axios from "axios";
import Login from './components/screens/Login';
import SelecionarFazenda from './components/screens/SelecionarFazenda';
import Dashboard from './components/screens/Dashboard';

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("nome");
      localStorage.removeItem("usuario_id");
      localStorage.removeItem("perfil");
      localStorage.removeItem("pode_criar_tarefas");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

function verificarTokenExpirado() {
  const token = localStorage.getItem("token");
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp < Date.now() / 1000) {
      localStorage.removeItem("token");
      localStorage.removeItem("nome");
      localStorage.removeItem("usuario_id");
      localStorage.removeItem("perfil");
      localStorage.removeItem("pode_criar_tarefas");
      return true;
    }
    return false;
  } catch {
    localStorage.removeItem("token");
    localStorage.removeItem("nome");
    localStorage.removeItem("usuario_id");
    localStorage.removeItem("perfil");
    localStorage.removeItem("pode_criar_tarefas");
    return true;
  }
}

export default function App() {
  const [usuario, setUsuario] = useState(() => {
    if (verificarTokenExpirado()) return null;
    const nome = localStorage.getItem("nome");
    const id = localStorage.getItem("usuario_id");
    const perfil = localStorage.getItem("perfil");
    if (nome && id) return { nome, id: parseInt(id), perfil };
    return null;
  });
  const [fazendaSelecionada, setFazendaSelecionada] = useState(null);
  useEffect(() => { if (verificarTokenExpirado()) { setUsuario(null); setFazendaSelecionada(null); } }, []);
  const handleLogin = dados => setUsuario(dados);
  const handleLogout = () => {
    localStorage.removeItem("token"); localStorage.removeItem("nome");
    localStorage.removeItem("usuario_id"); localStorage.removeItem("perfil");
    localStorage.removeItem("pode_criar_tarefas");
    setUsuario(null); setFazendaSelecionada(null);
  };
  if (!usuario) return <Login onLogin={handleLogin} />;
  if (!fazendaSelecionada) return <SelecionarFazenda usuario={usuario} onSelecionar={setFazendaSelecionada} onLogout={handleLogout} />;
  return <Dashboard usuario={usuario} fazenda={fazendaSelecionada} onVoltarFazendas={() => setFazendaSelecionada(null)} onLogout={handleLogout} />;
}